import React, { useContext, useEffect, useState } from "react";
import { classNames } from "@utilities";
import { CommentInputProps, KnowledgeHubBookContextProps } from "@models/ui";
import { KhBookContext } from "../../kh-book-context";
import { BrowserCustomerClient } from "@client";
import { ResourceCommentInputModel } from "@models/api";
import { useNavigate } from "@remix-run/react";

const InputCommentComponent: React.FC<CommentInputProps> = (commentInputProps) => {
    const KhBookData = useContext<KnowledgeHubBookContextProps>(KhBookContext);
    const [isEmpty, setIsEmpty] = useState<boolean>(true);
    const [error, setError] = useState<string>("");
    const navigate = useNavigate();

    const [profileImage, setProfileImage] = useState<string>("");
    useEffect(() => {
        if (KhBookData.customerProfile?.profile_picture === "") {
            return;
        }

        if (KhBookData.customerProfile?.profile_picture !== "") {
            (async () => {
                const client = new BrowserCustomerClient();
                const profileImgResp = await client.GetBucketFileUrl({ key: KhBookData.customerProfile?.profile_picture ?? "" });
                const profileImgUrl = profileImgResp.data;
                setProfileImage(profileImgUrl);
            })();
        }
    }, [KhBookData.customerProfile]);

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.value !== "") {
            setIsEmpty(false);
            setError("");
        } else {
            setIsEmpty(true);
        }
    }

    const handlePostClick = async () => {
        if (!KhBookData.inputRef.current?.value.trim()) {
            setError("Please enter a comment");
            return;
        }

        if (KhBookData.inputRef.current) {
            const comment = KhBookData.inputRef.current.value;

            const data: ResourceCommentInputModel = {
                resourceId: KhBookData.data?.resourceId as string,
                comment: comment,
            }

            if (commentInputProps.parentId) {
                data.parentId = commentInputProps.parentId
            }

            try {
                const client = new BrowserCustomerClient();
                const response = await client?.SaveResourceComment(data);
                if (response?.success) {
                    KhBookData.inputRef.current.value = "";
                    setIsEmpty(true);
                    setError("");
                    navigate(0);
                    // commentInputProps.setComments(prevComments => [...prevComments, respJson]);
                    if (commentInputProps.handleReplyClick)
                        commentInputProps.handleReplyClick();
                    else
                        commentInputProps.handleCommentClick();
                }
            } catch (error) {
                commentInputProps.setIsCommentsPopupOpen(true);
            }
        }
    }

    return (
        <div className="comment-post">
            <div className="post">
                <div className="">
                    {
                        profileImage !== "" ?
                            <img src={profileImage} alt="profile_pic" className="w-[32px] h-[32px] rounded-3xl" />
                            :
                            <p className="logo text-white"> {KhBookData.customerProfile.name[0]} </p>
                    }
                </div>
                <input
                    type="text"
                    id="typing"
                    name="typing"
                    placeholder=""
                    className="input-element"
                    ref={KhBookData.inputRef}
                    onChange={handleInputChange}
                />
            </div>
            {error && <div className="empty-comment-error-mobile ">{error}</div>}
            <div className="post-button">
                <button
                    className={classNames(!isEmpty ? "button-section-active" : "button-section")}
                    onClick={handlePostClick}
                >
                    <div className="button-text">
                        <p className="text">Post</p>
                    </div>
                </button>
            </div>
        </div>
    )
}

export default InputCommentComponent;